module.exports = __webpack_public_path__ + "assets/img/icon_service5.be47090a.png";